module.exports = __webpack_public_path__ + "static/media/pure.33c2d0b7.jpg";